// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createVendorPoSettings = (client) => ({
    /**
     * `POST /vendor/po-settings`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorUpsertPoSettings
     * @source apps/backend/src/api/vendor/po-settings/route.ts
     */
    create: (body, query, headers) => client.fetch("/vendor/po-settings", { method: "POST", body, query, headers }),
    /**
     * `GET /vendor/po-settings`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetPoSettings
     * @source apps/backend/src/api/vendor/po-settings/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/po-settings", { method: "GET", query, headers }),
});
//# sourceMappingURL=po-settings.js.map